module.exports = __webpack_public_path__ + "img/cover.24cc987d.webp";